import { render, staticRenderFns } from "./UiEditorInspector.vue?vue&type=template&id=33eb9f0e"
import script from "./UiEditorInspector.vue?vue&type=script&lang=js"
export * from "./UiEditorInspector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports